import { render, staticRenderFns } from "./aiNav.vue?vue&type=template&id=137e1394&scoped=true"
import script from "./aiNav.vue?vue&type=script&lang=js"
export * from "./aiNav.vue?vue&type=script&lang=js"
import style0 from "./aiNav.vue?vue&type=style&index=0&id=137e1394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e1394",
  null
  
)

export default component.exports